import { LinearProgress, Typography } from '@material-ui/core';
import { Check } from '@material-ui/icons';
import {
  ColorDynamic,
  Column,
  Columns,
  Inline,
  Stack,
} from '@superdispatch/ui';
import { Box } from '@superdispatch/ui-lab';
import styled from 'styled-components';

const BorderLinearProgress = styled(LinearProgress)`
  background-color: ${ColorDynamic.Silver400};
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
`;

const StepItem = styled.div`
  padding: 16px;
  width: 100%;
  text-align: center;
`;

interface VehiclesSetupStepItemProps {
  completed?: boolean;
  active?: boolean;
  label: string;
  description: string;
}

function VehiclesSetupStepItem({
  label,
  description,
  completed,
  active,
}: VehiclesSetupStepItemProps) {
  return (
    <StepItem>
      <Stack space="none">
        <Inline horizontalAlign="center" verticalAlign="center">
          {completed && <Check color="primary" fontSize="small" />}
          <Typography
            color={active ? 'primary' : 'textSecondary'}
            variant="body1"
          >
            {label}
          </Typography>
        </Inline>
        <Typography
          color={active ? 'textPrimary' : 'textSecondary'}
          variant={active ? 'body1' : 'inherit'}
        >
          {description}
        </Typography>
      </Stack>
    </StepItem>
  );
}

interface VehiclesSetupStepperProps {
  step: 1 | 2;
}

export function VehiclesSetupStepper({ step }: VehiclesSetupStepperProps) {
  return (
    <Box marginBottom="-xxsmall">
      <Columns align="center">
        <Column width="1/2">
          <VehiclesSetupStepItem
            label="STEP 1"
            description="Company Information"
            active={step === 1}
            completed={step > 1}
          />
        </Column>
        <Column width="1/2">
          <VehiclesSetupStepItem
            label="STEP 2"
            description="Connection Details"
            active={step === 2}
          />
        </Column>
      </Columns>
      <BorderLinearProgress
        value={step === 1 ? 50 : 100}
        variant="determinate"
      />
    </Box>
  );
}
